import React, { useState } from "react";
import ReactDOM from "react-dom";
import { addNewAddress } from "../services/authenticatedRequests";
import { toast } from "react-toastify";

const AddAddressModalCheckout = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    company: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    postCode: "",
    country: "",
    email: "",
    phone: "",
  });
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Call the backend API to add the new address.
      const savedAddress = await addNewAddress(formData);
      //onSave(savedAddress); // Pass the response back to parent.
      toast.success("Address saved successfully.");
      onClose();
    } catch (error) {
      console.error("Error saving address:", error.message);
      toast.error("Error saving address. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return ReactDOM.createPortal(
    <div
      className="modal d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog">
        <div
          className="modal-content p-24 border border-gray-100 hover-border-main-600 transition-1 rounded-8"
          style={{ borderRadius: "0" }}
        >
          <button
            onClick={onClose}
            className="absolute  text-sm text-gray-700 ms-auto"
          >
            ×
          </button>
          <div className="modal-header border-0 p-0 mb-10">
            <h2 className="modal-title text-sm text-neutral-900 fw-semibold ">
              Add New Address
            </h2>
          </div>
          <div className="modal-body p-0">
            <form onSubmit={handleSubmit}>
              {[
                { label: "First Name", name: "firstName", required: true },
                { label: "Last Name", name: "lastName", required: true },
                { label: "Company", name: "company", required: false },
                { label: "Address Line 1", name: "address1", required: true },
                { label: "Address Line 2", name: "address2", required: false },
                { label: "City", name: "city", required: true },
                { label: "State", name: "state", required: true },
                { label: "Post Code", name: "postCode", required: true },
                { label: "Country", name: "country", required: true },
                { label: "Email", name: "email", required: true },
                { label: "Phone", name: "phone", required: true },
              ].map((field, index) => (
                <div className="mb-4" key={index}>
                  <label className="block text-gray-600 mb-1 text-sm">
                    {field.label}
                  </label>
                  <input
                    type={field.name === "email" ? "email" : "text"}
                    name={field.name}
                    className="common-input-two w-full text-sm"
                    value={formData[field.name]}
                    onChange={handleChange}
                    required={field.required}
                  />
                </div>
              ))}
              <button
                type="submit"
                className="btn btn-main btn-sm"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save Address"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById("modal-root")
  );
};

export default AddAddressModalCheckout;
